import { observable } from 'mobx';

const PLATFORM_STORE = observable({
    WHICH_PLATFORM : "",
});

export {PLATFORM_STORE};